"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("./constants");
exports.default = (function (entity, id) {
    return new Promise(function (resolve, reject) {
        var pending;
        var eventHandler = function (event) {
            var detail = event.detail;
            // only resolve the actual window and not when it opens
            if (detail.bron !== entity || detail.bronid !== id) {
                return;
            }
            switch (detail.status) {
                case constants_1.CompendaStatus.Opened:
                    pending = false;
                    break;
                case constants_1.CompendaStatus.NotFound:
                    document.removeEventListener('compenda', eventHandler);
                    reject(constants_1.Errors.EntityNotFound);
                    break;
                case constants_1.CompendaStatus.Closed:
                    document.removeEventListener('compenda', eventHandler);
                    resolve();
                    break;
            }
        };
        document.addEventListener('compenda', eventHandler);
        openEntityTroughIframe(entity, id);
        pending = true;
        setTimeout(function () {
            if (pending) {
                reject(constants_1.Errors.CompendaNotResponding);
            }
        }, 500);
    });
});
var openEntityTroughIframe = function (entity, id) {
    var url = 'http://compenda/' + entity + '/' + String(id);
    var iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = url;
    iframe.onload = function () { iframe.parentNode.removeChild(iframe); };
    document.body.appendChild(iframe);
};
